import { createContext } from 'react';

import type { ToastTone } from '@/components/Toaster/Toaster';

export interface ToastOptions {
  title: string;
  description?: string;
}

export type ToastApi = Record<ToastTone, (options: ToastOptions) => void>;

const ignore = () => {};

/** Outside a provider every call is a no-op, so a container renders alone in a test. */
export const ToastContext = createContext<ToastApi>({
  success: ignore,
  info: ignore,
  warning: ignore,
  error: ignore,
});
